<common-rebalancing-sell-portfolio-percentage-modal
  [(isOpen)]="isSellPortfolioPercentageModalOpen"
></common-rebalancing-sell-portfolio-percentage-modal>
<common-rebalancing-sell-portfolio-value-modal
  [(isOpen)]="isSellPortfolioValueModalOpen"
></common-rebalancing-sell-portfolio-value-modal>

<div class="mt-4">
  <div class="h-8 flex justify-between items-end">
    <span class="text-gray-400 self-center">{{
      'rebalancing.swapFrom' | translate
    }}</span>
    <ng-container *ngIf="store.sellEntries.length > 0 && isEditable">
      <div class="flex items-center">
        <span class="text-gray-400 text-xs">
          {{ 'rebalancing.quickActions.info' | translate }}:
        </span>
        <div class="ml-2 bg-gray-700 rounded-md flex">
          <a
            (click)="onOpenSellPortfolioPercentageModal()"
            [floatUi]="'rebalancing.quickActions.sellPercentage' | translate"
            class="flex items-center rounded-l-md py-2 px-2 cursor-pointer hover:bg-gray-600"
          >
            <ng-icon name="hero-percent-badge-mini"></ng-icon>
          </a>
          <a
            (click)="onOpenSellPortfolioValueModal()"
            [floatUi]="'rebalancing.quickActions.sellValue' | translate"
            class="flex items-center py-2 px-2 cursor-pointer hover:bg-gray-600"
          >
            <ng-icon name="hero-currency-dollar-mini"></ng-icon>
          </a>
          <a
            *ngIf="isWalletRebalancing()"
            (click)="onClearAllClick()"
            [floatUi]="'rebalancing.quickActions.clearAll' | translate"
            class="flex items-center rounded-r-md py-2 px-2 cursor-pointer hover:bg-gray-600"
          >
            <ng-icon name="hero-x-circle-mini"></ng-icon>
          </a>
          <a
            *ngIf="!isWalletRebalancing()"
            (click)="onExcludeAllClick()"
            [floatUi]="'rebalancing.quickActions.excludeAll' | translate"
            class="flex items-center rounded-r-md py-2 px-2 cursor-pointer hover:bg-gray-600"
          >
            <ng-icon name="hero-x-circle-mini"></ng-icon>
          </a>
        </div>
      </div>
    </ng-container>
  </div>
  <div
    *ngIf="!store.sellEntries.length"
    class="mt-2 p-2 md:p-4 rounded-lg bg-gray-900 flex"
  >
    <button
      (click)="openSelectDialog()"
      *ngIf="
        (assetRepository.assets$ | async)?.length &&
          (signerRepository.connected$ | async) &&
          (!rebalancingRepository.store.getValue().tradingPaused ||
            rebalancingRepository.store.getValue().capacityReached);
        else disabledButton
      "
      class="button-white rounded-md button-sm"
    >
      <span class="mx-2 uppercase">{{ 'global.select' | translate }}</span>
      <ng-icon name="hero-plus-mini"></ng-icon>
    </button>
    <ng-template #disabledButton>
      <button
        (click)="onDisabledButtonClicked()"
        class="button-white rounded-md button-sm disabled"
      >
        <span class="mx-2 uppercase">{{ 'global.select' | translate }}</span>
        <ng-icon name="hero-plus-mini"></ng-icon>
      </button>
    </ng-template>
  </div>

  <common-rebalancing-sell-entry
    *ngFor="let entry of getIncludedSellEntries()"
    [sellEntry]="entry"
    [isEditable]="isEditable"
    (openSelectDialog)="openSelectDialog()"
    (removeClick)="removeEntry($event)"
    (sellEntryChange)="onSellEntryChange()"
  ></common-rebalancing-sell-entry>

  <div
    *ngIf="
      store.sellEntries.length > 0 && getIncludedSellEntries().length === 0
    "
    class="alert alert-warning"
  >
    {{ 'rebalancing.includeAtLeastOne' | translate }}
  </div>
  <div *ngIf="getExcludedSellEntries().length > 0">
    <div class="mt-4 flex justify-between items-end">
      <div class="flex items-center">
        <span class="text-sm text-gray-400"
          >{{ 'rebalancing.excluded' | translate }} ({{
            getExcludedSellEntries().length
          }})</span
        >
        <ng-icon
          (click)="onToggleShowExcludedClick()"
          class="ml-2 hover:text-green cursor-pointer"
          name="{{
            showExcluded ? 'hero-chevron-down-mini' : 'hero-chevron-up-mini'
          }}"
          size="18"
        ></ng-icon>
      </div>

      <a
        *ngIf="isEditable"
        (click)="onIncludeAllClick()"
        class="mr-2 text-sm text-white cursor-pointer"
        >{{ 'rebalancing.includeAll' | translate }}</a
      >
    </div>
    <ng-container *ngIf="showExcluded">
      <common-rebalancing-sell-entry
        *ngFor="let entry of getExcludedSellEntries()"
        [sellEntry]="entry"
        [isEditable]="isEditable"
        (openSelectDialog)="openSelectDialog()"
        (removeClick)="removeEntry($event)"
        (sellEntryChange)="onSellEntryChange()"
      ></common-rebalancing-sell-entry>
    </ng-container>
  </div>

  <div
    *ngIf="isEditable && isWalletRebalancing()"
    class="mt-4 mx-4 flex justify-between items-center"
  >
    <ng-container
      *ngIf="
        (assetRepository.assets$ | async)?.length &&
          (signerRepository.connected$ | async) &&
          !rebalancingRepository.store.getValue().tradingPaused;
        else disabledButtons
      "
    >
      <div>
        <button
          (click)="openSelectDialog()"
          class="button-transparent button-sm !pt-0 mb-1"
          tabindex="-1"
        >
          <div class="icon-wrapper">
            <ng-icon name="hero-plus-mini"></ng-icon>
          </div>
          <span class="ml-4 text-sm">{{
            'rebalancing.addTokens' | translate
          }}</span>
        </button>
        <button
          (click)="sellAll()"
          class="button-transparent button-sm"
          tabindex="-1"
        >
          <div class="icon-wrapper">
            <ng-icon name="hero-bars-arrow-down-mini"></ng-icon>
          </div>
          <span class="ml-4 text-sm">{{
            'rebalancing.sellAll' | translate
          }}</span>
        </button>
      </div>
    </ng-container>
    <ng-template #disabledButtons>
      <button
        (click)="onDisabledButtonClicked()"
        class="button-transparent button-sm disabled"
        tabindex="-1"
      >
        <div class="icon-wrapper">
          <ng-icon name="hero-plus-mini"></ng-icon>
        </div>
        <span class="ml-4 text-sm">{{
          'rebalancing.addTokens' | translate
        }}</span>
      </button>
    </ng-template>
    <span
      *ngIf="store.buyEntries.length"
      class="self-start flex-grow text-right text-sm text-white"
      >{{ 'rebalancing.payValue' | translate }} :
      {{ getPayValueSum() | currency }}</span
    >
  </div>
</div>

<common-rebalancing-select-tokens-modal
  (selectedAssetsChange)="onSelectedAssetsChange($event)"
  *ngIf="isSelectDialogOpen && isEditable"
  [(isOpen)]="isSelectDialogOpen"
  [mustBeSellable]="true"
  [hideZeroBalanceTokens]="true"
  [selectedAssets]="getSellEntriesAssets()"
></common-rebalancing-select-tokens-modal>
